module.exports = new __parcel__URL__("bitget.76135eab.svg").toString();